<div class="row_1">
    <div>
        <label class="label tab-heading titlered">Contingency PCS</label>
        <label class="label tab-heading" *ngIf="isAccessible" (click)="openRouteLevel('contingency-master-tables')">
            Contingency Master Tables</label>

        <button class="primarybutton" style="float: right;" *ngIf="false" (click)="AddToQueue();">Add To
            Queue</button>
    </div>
    <div class="top_grid_agg">
        <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>
        <img src="./assets/images/refresh_button.svg" class="refresh-button" (click)="getBaseDropDownDataAPI()">
        <app-periods-dropdown periodLabel="Period" (eventHandler)="componentEventHandler($event);"
            style="margin-right: 4%;">
        </app-periods-dropdown>
        <button class="primarybutton" *ngIf="isAccessible" (click)="AddContignency();">Add</button>
        <button *ngIf="updatedRowIds.length && isAccessible" class="primarybutton"
            (click)="displayDeleteDialog();">Delete</button>
        <label class="exportGray export-icon">Export All <span>
                <img src="./assets/images/export_black.svg" (click)="exportHistory();" class="exportGrayImg"
                    title="Export All"></span></label>
        <img src="./assets/images/vertical_line.svg" class="line">
        <label class="exportGray">Export Cont DS Request <span>
                <img src="./assets/images/export_black.svg" (click)="exportHistoryOnlyDS();" class="exportGrayImg"
                    title="Export Cont DS Request "></span></label>

        <div class="grid-agg">
            <label class="gridcaption">Contingency PCS</label>
            <ag-grid-angular #ContigencyPCSGrid style="width:100%;height: 410px;" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
                (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true"
                [defaultColDef]="defaultColDef" [suppressRowClickSelection]="true" [columnDefs]="columnDefs"
                [rowData]="displayRowData"   [context]="context" [pagination]="true"
                [paginationPageSize]="rowCount" [icons]="icons" [gridOptions]="gridOptions">
            </ag-grid-angular>
            <div class="row col-12" style="bottom: 24px;position: relative; padding-left :13px">

                <div class="w-25 col-4 ">
                    <div>
                        <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                        <select class="page-drpdwn" (change)="onPageSizeChanged($event)">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="ALL" selected>ALL</option>
                        </select>
                        <!-- <label style="padding-left:9px"> of {{rowCount}}</label> -->
                    </div>
                </div>

                <div style="display: flex;" class="pagination_text col-4 offset-2">

                    <!-- first -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToFirstPage()"
                        [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                        first_page</mat-icon>

                    <!-- previous -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToPreviousPage()"
                        [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                        keyboard_arrow_left</mat-icon>

                    <p class="total_row_text">Total Row {{rowCount}}</p>

                    <!-- next -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                        (click)="goToNexpage()">keyboard_arrow_right
                    </mat-icon>

                    <!-- last -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                        (click)="goToLastPage()">last_page
                    </mat-icon>

                </div>

            </div>

        </div>
        <div>
            <button class="secondarybutton" style="margin:0 1% 1% 4%"
                (click)="getBaseDropDownDataAPI();">CANCEL</button>
            <button class="primarybutton" style="float: right;margin:0 4% 1% 1%"
                (click)="saveContingencyPCS();">SAVE</button>
        </div>
    </div>
</div>